import { html } from "lit";
import { createRef, ref } from "lit-html/directives/ref.js";
import { ifDefined } from "lit-html/directives/if-defined.js";
import { prop } from "../../../decorators/prop/index.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { preventDefault } from "../../../decorators/preventDefault.js";
import { BaseComponent } from "../../BaseComponent.js";
import "../Button/index.js";
import "../Link/index.js";
import "../../atom/Row/index.js";
import "../../atom/Text/index.js";
import "../../atom/Column/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfFileInput = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_level = "link";
    this.dsf_multiple = false;
    this._inputRef = createRef();
  }
  onUploadClick(e) {
    var _a;
    e.preventDefault();
    (_a = this._inputRef.value) == null ? void 0 : _a.click();
  }
  onFileChange(e) {
    const {
      currentTarget: { files }
    } = e;
    const fileList = files ? [...files] : [];
    this.emit({ name: "files", payload: fileList });
  }
  getButton() {
    if (this.dsf_level === "link") {
      return html`
        <dsf-link
          dsf_icon="Upload"
          dsf_size="medium"
          @click=${this.onUploadClick}
          ?disabled=${this.disabled}
        >
          ${this.dsf_label}
        </dsf-link>
      `;
    } else {
      return html`
        <dsf-button
          dsf_icon_left="Upload"
          dsf_size="small"
          dsf_level=${this.dsf_level}
          @click=${this.onUploadClick}
          ?disabled=${this.disabled}
        >
          ${this.dsf_label}
        </dsf-button>
      `;
    }
  }
  render() {
    return html`
      ${this.getButton()}
      <input
        @change=${this.onFileChange}
        accept=${ifDefined(this.dsf_accepted_mime_types)}
        .multiple=${this.dsf_multiple}
        style="display: none"
        type="file"
        ${ref(this._inputRef)}
      />
    `;
  }
};
__decorateClass([
  prop({ type: String })
], DsfFileInput.prototype, "dsf_level", 2);
__decorateClass([
  prop({ type: String })
], DsfFileInput.prototype, "dsf_label", 2);
__decorateClass([
  prop({ type: Boolean })
], DsfFileInput.prototype, "dsf_multiple", 2);
__decorateClass([
  prop({ type: String })
], DsfFileInput.prototype, "dsf_accepted_mime_types", 2);
__decorateClass([
  prop({ type: Boolean })
], DsfFileInput.prototype, "disabled", 2);
__decorateClass([
  preventDefault
], DsfFileInput.prototype, "onUploadClick", 1);
DsfFileInput = __decorateClass([
  defineElement("dsf-file-input")
], DsfFileInput);
export {
  DsfFileInput
};
